import React from 'react';
import { Grid } from '@material-ui/core' 

import NavBar from '../../components/NavBar'

export function DashboardLayout({ children }) {
  return (
    <>
      <NavBar />
      <Grid 
        container 
        direction='row' 
        spacing={1}
        style={{ paddingTop: '5vh' }}
      >
        {children}
      </Grid>
    </>
  );
}

export default DashboardLayout;
